export default __webpack_public_path__ + "locales/ja-JP/InfoPanel.json?hash=1a67a921754df37da6dfe90fe8dd4932";